module.exports = __webpack_public_path__ + "img/bg_lobby_top.ce8d04c6.png";